import pxToRem from "../functions/pxToRem";

export default function popover({ colors, boxShadows, borders }) {
  const { transparent } = colors;
  const { lg } = boxShadows;
  const { borderRadius } = borders;

  const popover = {
    styleOverrides: {
      paper: {
        backgroundColor: transparent.main,
        boxShadow: lg,
        padding: pxToRem(8),
        borderRadius: borderRadius.md,
      },
    },
  };

  return popover;
}
